export const CANCEL_CAMPAIGN_MODAL_TEST_ID = 'cancel-campaign-modal';
export const CANCEL_CAMPAIGN_MODAL_CONFIRM_BUTTON_TEST_ID = `${CANCEL_CAMPAIGN_MODAL_TEST_ID}-confirm-button`;
